module.exports = __webpack_public_path__ + "static/media/Detroit_City.bc23243f.png";